module.exports = __webpack_public_path__ + "img/xinzhuang-4.4bef0731.jpg";